import { configureStore } from "@reduxjs/toolkit";
import holidayReducer from "./slices/holidaySlice";
import flightReducer from "./slices/flightSlice";
import staysReducer from "./slices/staysSlice";
import activityReducer from "./slices/activitySlice";
import commonReducer from "./slices/commonSlice";

export const store = configureStore({
  reducer: {
    holiday: holidayReducer,
    flight: flightReducer,
    stays: staysReducer,
    activity: activityReducer,
    common: commonReducer,
  },
});

export default store;
